import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IRequestTypeAddPayload, IRequestTypeUpdatePayload } from './cerere-type.interface';

@Injectable({
    providedIn: 'root'
})
export class CerereTypeService {
    private token!: string;
    private basePath = environment.interop.basePath;
    private httpOptions: any;
    private getRequestTypesDTUrl = this.basePath + environment.interop.dgitl.nomenclatoare.cerereType.getCerereTypesDT;
    private storeRequestTypeUrl = this.basePath + environment.interop.dgitl.nomenclatoare.cerereType.storeCerereType;
    private updateRequestTypeUrl = this.basePath + environment.interop.dgitl.nomenclatoare.cerereType.putCerereType;
    private deleteRequestTypeUrl = this.basePath + environment.interop.dgitl.nomenclatoare.cerereType.deleteCerereType;
    private getRequestTypesActiveUrl = this.basePath + environment.interop.urbanism.nomenclatoare.cerereType.getCerereTypesActive;
    private getRequestTypesPublicUrl = this.basePath + environment.interop.urbanism.nomenclatoare.cerereType.getCerereTypesActivePublic;

    private changeStatusActiveUrl = this.basePath + environment.interop.dgitl.nomenclatoare.cerereType.changeStatusCerereTypeActive;

    private changeStatusPublicUrl = this.basePath + environment.interop.dgitl.nomenclatoare.cerereType.changeStatusCerereTypePublic;

    private clearCacheUrl = this.basePath + environment.interop.dgitl.nomenclatoare.cerereType.clearCache;

    constructor(private http: HttpClient) { }

    getRequestTypesDT() {
        return this.http.get(this.getRequestTypesDTUrl, this.httpOptions);
    }

    clearCache() {
        return this.http.get(this.clearCacheUrl, this.httpOptions);
    }

    addRequestType(data: IRequestTypeAddPayload) {
        return this.http.post(this.storeRequestTypeUrl, data, this.httpOptions);
    }

    updateRequestType(data: IRequestTypeUpdatePayload) {
        return this.http.put(this.updateRequestTypeUrl, data, this.httpOptions);
    }

    deleteRequestType(requestTypeId: number) {
        return this.http.delete(this.deleteRequestTypeUrl + requestTypeId);
    }

    getActiveRequestTypes() {
        return this.http.get(this.getRequestTypesActiveUrl, this.httpOptions);
    }

    getPublicRequestTypes() {
        return this.http.get(this.getRequestTypesPublicUrl, this.httpOptions);
    }

    changeStatuseActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusePublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${this.token}`
            })
        };
    }
}
